module.exports = __webpack_public_path__ + "media/src/images/partners/padova-c5fc18cddb07264c851bc0cf5c06cef0.jpg";